export default "__VITE_ASSET__bXL8ZMEX__"